var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-item",style:({
    marginRight: _vm.isRowEnd ? 0 : _vm.grid.rowMargin,
    marginBottom: _vm.isLastRow ? '0' : _vm.marginBottom ? _vm.marginBottom + 'px' : _vm.grid.colMargin,
    width: `calc(${_vm.calcWidth})`
  }),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }